import LayoutExplore from '@/components/layouts/LayoutExplore';
import ExploreDashboard from '@/components/ExploreDashboard';
import ExploreAirport from '@/components/ExploreAirport';
import ExploreAirportStores from '@/components/ExploreAirportStores';

export default {
  path: '/explore',
  component: LayoutExplore,
  meta: {
    public: true,
  },
  children: [
    {
      path: '',
      name: 'ExploreDashboard',
      component: ExploreDashboard,
    },
    {
      path: ':id',
      name: 'ExploreAirport',
      component: ExploreAirport,
      props: true,
    },
    {
      path: ':id/stores',
      name: 'ExploreAirportStores',
      component: ExploreAirportStores,
      props: true,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/routes.explore.js